<template>
	<div v-loading="loading" style="position: relative;flex: 1;height: 100%;overflow: hidden;">
		<div style="width: 100%;height: 100%;padding: 15px;overflow-x: hidden;overflow-y: auto;">
			<!-- 顶部查询 -->
			<div style="border: 1px solid #ccc;background: #f7f7f7;border-radius: 5px;">
				<div class="base_inquire" style="padding: 20px 30px 5px;">
					
					
					<div class="b_item">
						<span class="b_label">机构名称：</span>
						<el-input v-model="search_firmName" class="b_inp" placeholder="机构名称"></el-input>
					</div>
					
					<div class="b_item">
						<span class="b_label">患者姓名：</span>
						<el-input v-model="search_name" class="b_inp" placeholder="患者姓名"></el-input>
					</div>
					
					<div class="b_item">
						<span class="b_label">患者账号：</span>
						<el-input v-model="search_code" class="b_inp" placeholder="患者账号"></el-input>
					</div>
					
					<div class="b_item">
						<span class="b_label">提醒时间：</span>
						<el-date-picker
							v-model="search_time"
							:editable="false"
							placeholder="提醒时间"
							type="date"
							value-format="yyyy-MM-dd"
						>
						</el-date-picker>
					</div>
					
					<el-button type="primary" @click="handleSearchClick">查询</el-button>
				</div>
			</div>
			<!-- 顶部查询 end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="name"
						label="患者姓名"
					>
					</el-table-column>
					<el-table-column
						prop="code"
						label="患者账号"
					>
					</el-table-column>
					<el-table-column
						prop="firmName"
						label="所属机构"
					>
					</el-table-column>
					<el-table-column
						prop="matter"
						label="备忘事宜"
					>
					</el-table-column>
					<el-table-column
						label="提醒时间"
					>
						<template slot-scope="scope">
							<span>{{ scope.row.time }} <span v-if="scope.row.time == nowDate" style="color: #f00;">※</span></span>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination
						layout="total, prev, pager, next, jumper"
						next-text="下一页" 
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange"
					>
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
	</div>
</template>

<script>
	import Api from '../../../../api/index.js';
	import { mapState } from 'vuex';
	import BaseMethods from '../../../../assets/js/base.js';
	
	export default {
		mounted() {
			this.findMemos();
		},
		data() {
			return {
				nowDate: BaseMethods.getTime(new Date().getTime()),
				
				loading: false,
				search_firmName: '',
				search_name: '',
				search_code: '',
				search_time: '',
				
				tableData: [],
				
				currentPage: 1,
				total: 0
			}
		},
		computed: {
			...mapState([
				'authInfo'
			])
		},
		methods: {
			/******************** @Events **************************/
			// 点击查询
			handleSearchClick() {
				this.currentPage = 1;
				this.findMemos();
			},
			// 切换页码
			handlePageChange(page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.findMemos();
				}
			},
			
			/******************** @Function **************************/
			// 查询备忘录
			findMemos() {
				const that = this;
				that.loading = true;
				var requestData = { 
					"category": that.authInfo.ucategory,
					"code": that.search_code,
					"enterpriseId": that.authInfo.uenterpriseId,
					"enterpriseName": that.search_firmName,
					"limit": 10,
					"name": that.search_name,
					"pageNum": that.currentPage,
					"userId": null
				};
				Api.findMemosByCondition(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						let data = [];
						that.total = res.data.data.totalItems;
						res.data.data.data.forEach((v) => {
							data.push({
								name: v.userName,
								code: v.userCode,
								firmName: v.enterpriseName,
								matter: v.memorandumContent || '',
								time: v.time || ''
							});
						});
						that.tableData = data;
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		}
	}
</script>

<style scoped>
</style>
